import { z } from 'zod';

export const deviceInfoSchema = z.object({
  deviceId: z.string().optional(),
  applicationBundleId: z.string().optional(),
  appName: z.string().optional(),
  adjustAppToken: z.string().optional(),
  dev: z.string().optional(),
  systemVersion: z.string().optional(),
  deviceName: z.string().optional(),
  deviceBrand: z.string().optional(),
  deviceType: z.string().optional(),
  deviceModel: z.string().optional(),
  osName: z.string().optional(),
  osVersion: z.string().optional(),
  appVersion: z.string().optional(),
  isTablet: z.string().optional(),
  appBuildVersion: z.string().optional(),
  regionCode: z.string().optional(),
  country: z.string().optional(),
  language: z.string().optional(),
  adid: z.string().optional(),
  adidfa: z.string().optional(),
  idfa: z.string().optional(),
  idfv: z.string().optional(),
  google_adid: z.string().optional(),
});

export const deviceInfoKeys = deviceInfoSchema.keyof().options;
export type DeviceInfo = z.infer<typeof deviceInfoSchema>;
export type DeviceInfoProperty = keyof DeviceInfo;
